import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import BackgroundImage from "./BackgroundImage";

const SectionRoot = styled(Box)(({ theme, bgcolor }) => {
  const backgroundColor = {
    default: theme.palette.background.default,
    light: alpha(theme.palette.background.default, 0.03),
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    transparent: 'transparent',
    inherit: 'inherit'
  }[bgcolor];

  return {
    position: "relative",
    backgroundColor: backgroundColor,
    color: theme.palette.getContrastText(backgroundColor),
    "& + &": {
      borderTop: `1px solid ${alpha(backgroundColor, 0.09)}`
    },
    "& > .MuiContainer-root": {
      position: "relative"
    }
  };
});

function Section(props) {
  const {
    bgcolor = "default",
    bgImage,
    bgImageOpacity,
    size = "normal",
    className,
    children,
    ...otherProps
  } = props;

  const verticalPadding = {
    normal: { xs: 4, sm: 6 }, // Adjusted padding for xs screens
    medium: { xs: 5, sm: 10 },
    large: { xs: 6, sm: 20 },
    auto: 0
  }[size];

  return (
    <SectionRoot
      component="section"
      py={verticalPadding}
      bgcolor={bgcolor}
      className={className}
      {...otherProps}
    >
      {bgImage && <BackgroundImage image={bgImage} opacity={bgImageOpacity} />}
      {children}
    </SectionRoot>
  );
}

export default Section;